import e from "../managers/braze-instance.js";
import { logger as r, IndexedDBAdapter as A } from "../../shared-lib/index.js";
import Q, { STORAGE_KEYS as o } from "../managers/storage-manager.js";
export function enableSDK() {
  new Q.ee(null, !0).remove(o.se);
  const a = A.ts.Zt;
  new A(a, r).re(a.hs.ae, a.ie),
    r.info("enableSDK was called"),
    e.destroy(!1),
    e.oe(!1);
}
